import { api } from './api';

export interface ChatMessage {
  role: 'user' | 'assistant';
  content: string;
}

export interface ChatToolCall {
  name: string;
  args: Record<string, unknown>;
}

export interface ChatDebugInfo {
  rounds: number;
  tools: ChatToolCall[];
  tokens: { prompt: number; output: number; total: number };
  latency_ms: number;
  model: string;
}

export interface ChatResponse {
  reply: string;
  tokens_remaining: {
    used: number;
    limit: number;
    remaining: number;
  };
  /** 開発環境(settings.DEBUG)のみ付与される。AIの思考トレース。 */
  _debug?: ChatDebugInfo;
}

export interface TokenStatus {
  used: number;
  limit: number;
  remaining: number;
}

export interface DailyLimitError {
  error: 'daily_limit_exceeded';
  remaining: TokenStatus;
}

export const aiApi = {
  sendMessage: async (message: string, history: ChatMessage[]): Promise<ChatResponse> => {
    const { data } = await api.post<ChatResponse>('/ai/chat/game/', { message, history });
    // 開発時はAIの思考トレースをコンソールに出す（Network タブでも確認可能）
    if (process.env.NODE_ENV === 'development' && data._debug) {
      // eslint-disable-next-line no-console
      console.debug('[AI debug]', data._debug);
    }
    return data;
  },

  getTokenStatus: async (): Promise<TokenStatus> => {
    const { data } = await api.get<TokenStatus>('/ai/chat/game/');
    return data;
  },
};
